import { ThemeProvider } from "@mui/material";
import React from "react";
import { Popup } from "scmp-sdk/components/popup";

import { StyledSignUpSuccessMessage } from "./styles";

export type Props = {
  isShow: boolean;
  onClose: () => void;
};

export const SignUpPopup: React.FunctionComponent<Props> = ({ isShow, onClose }) => (
  <Popup isShow={isShow} onClose={onClose}>
    <ThemeProvider
      theme={{
        signUpSuccess: {
          hasCheckEmail: true,
        },
      }}
    >
      <StyledSignUpSuccessMessage />
    </ThemeProvider>
  </Popup>
);

SignUpPopup.displayName = "SignUpPopup";
